<p-dialog [(visible)]="modalCreateClientService._visible" header="{{ 'CREATE_NEW_CLIENT' | translate }}" [modal]="true">


    <mat-card class="cardWithShadow" style="margin-top: 20px;">
        <mat-card-header style="margin-bottom: 30px;">
            <mat-card-title class="title">{{'PERSONAL_INFO' | translate}}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form class="card-content" [formGroup]="createClientForm">

                <div class="form-group row">
                    <div class="col-sm-3">
                        <div class="b-label-up">
                            <span for="inputEmail3" class="control-label col-form-label">
                                {{'NAME' | translate}} *</span>
                        </div>
                    </div>
                    <div class="col-sm-9">
                        <input type="text" class="form-control" id="inputEmail3" formControlName="name">
                        <div *ngIf="createClientForm.get('name').invalid && (createClientForm.get('name').dirty || createClientForm.get('name').touched)"
                            class="text-danger">
                            <div *ngIf="createClientForm.get('name').errors?.['required']">
                                {{
                                'FIELD_REQUIRED' | translate }}</div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-3">
                        <div class="b-label-up">
                            <span for="inputEmail3" class="control-label col-form-label">{{'EMAIL' |
                                translate}}
                                *</span>
                        </div>
                    </div>
                    <div class="col-sm-9">
                        <input type="email" class="form-control" id="inputEmail3" formControlName="email">
                        <div *ngIf="createClientForm.get('email').invalid && (createClientForm.get('email').dirty || createClientForm.get('email').touched)"
                            class="text-danger">
                            <div *ngIf="createClientForm.get('email').errors?.['required']">
                                {{
                                'FIELD_REQUIRED' | translate }}</div>
                            <div *ngIf="createClientForm.get('email').errors?.['email']">{{
                                'INVALID_EMAIL' | translate }}</div>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-sm-3">
                        <div class="b-label-up">
                            <span for="inputEmail3" class="control-label col-form-label">{{'DESCRIPTION' |
                                translate}}</span>
                        </div>
                    </div>
                    <div class="col-sm-9">
                        <textarea class="form-control" rows="3"
                            style="margin-top: 0px; margin-bottom: 0px; height: 90px;"
                            formControlName="description"></textarea>
                    </div>
                </div>

            </form>
        </mat-card-content>
    </mat-card>

    <mat-card class="cardWithShadow" style="margin-top: 20px;">
        <mat-card-header style="margin-bottom: 30px;">
            <mat-card-title class="title">{{ 'CLINIC_INFORMATION' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form class="form-horizontal b-form" [formGroup]="createClinicForm">
                <div class="custom-box">
                    <div class="form-group">
                        <div class="input-box">
                            <span>{{ 'CLINIC_NAME' | translate }} *</span>
                            <input required type="text" class="form-control" formControlName="name" id="name" />
                            <div *ngIf="createClinicForm.get('name').invalid && (createClinicForm.get('name').dirty || createClinicForm.get('name').touched)"
                                class="text-danger">
                                <div *ngIf="createClinicForm.get('name').errors?.['required']">
                                    {{ 'FIELD_REQUIRED' | translate }}</div>
                            </div>
                        </div>
                    </div>

                    <div formGroupName="shippingAddress">
                        <h4 class="mt-4">{{ 'SHIPPING_ADDRESS' | translate }}</h4>
                        <div class="flex-column">
                            <div class="input-box">
                                <span>{{ 'CONTACT_NAME' | translate }} *</span>
                                <input required type="text" formControlName="contactNameAndSurname" class="form-control"
                                    id="shippingContactNameAndSurname" />
                                <div *ngIf="createClinicForm.get('shippingAddress.contactNameAndSurname').invalid && (createClinicForm.get('shippingAddress.contactNameAndSurname').dirty || createClinicForm.get('shippingAddress.contactNameAndSurname').touched)"
                                    class="text-danger">
                                    <div
                                        *ngIf="createClinicForm.get('shippingAddress.contactNameAndSurname').errors?.['required']">
                                        {{ 'FIELD_REQUIRED' | translate }}</div>
                                </div>
                            </div>
                            <div class="input-box">
                                <span>{{ 'COUNTRY' | translate }} *</span>
                                <input required type="text" formControlName="country" class="form-control"
                                    id="shippingCountry" />
                                <div *ngIf="createClinicForm.get('shippingAddress.country').invalid && (createClinicForm.get('shippingAddress.country').dirty || createClinicForm.get('shippingAddress.country').touched)"
                                    class="text-danger">
                                    <div *ngIf="createClinicForm.get('shippingAddress.country').errors?.['required']">
                                        {{ 'FIELD_REQUIRED' | translate }}</div>
                                </div>
                            </div>
                            <div class="input-box">
                                <span>{{ 'CITY' | translate }} *</span>
                                <input required type="text" formControlName="city" class="form-control"
                                    id="shippingCity" />
                                <div *ngIf="createClinicForm.get('shippingAddress.city').invalid && (createClinicForm.get('shippingAddress.city').dirty || createClinicForm.get('shippingAddress.city').touched)"
                                    class="text-danger">
                                    <div *ngIf="createClinicForm.get('shippingAddress.city').errors?.['required']">
                                        {{ 'FIELD_REQUIRED' | translate }}</div>
                                </div>
                            </div>
                            <div class="input-box">
                                <span>{{ 'PROVINCE' | translate }}</span>
                                <input type="text" formControlName="province" class="form-control"
                                    id="shippingProvince" />
                            </div>
                            <div class="input-box">
                                <span>{{ 'STREET_NAME' | translate }}</span>
                                <input type="text" formControlName="streetNameAndNumber" class="form-control"
                                    id="shippingStreetNameAndNumber" />
                            </div>
                            <div class="input-box">
                                <span>{{ 'APARTMENT' | translate }}</span>
                                <input type="text" formControlName="apartmentOrOthers" class="form-control"
                                    id="shippingApartmentOrOthers" />
                            </div>
                            <div class="input-box">
                                <span>{{ 'POSTAL_CODE' | translate }}</span>
                                <input type="text" formControlName="postalCode" class="form-control"
                                    id="shippingPostalCode" />
                            </div>
                            <div class="input-box">
                                <span>{{ 'PHONE_NUMBER' | translate }}</span>
                                <input type="text" formControlName="phoneNumber" class="form-control"
                                    id="shippingPhoneNumber" />
                            </div>
                        </div>
                    </div>

                    <div formGroupName="billingAddress">
                        <h4 class="mt-4">{{ 'BILLING_ADDRESS' | translate }}</h4>
                        <div class="form-group">
                            <div class="input-box my-3">
                                <input class="mr-2" type="checkbox" id="sameAsShipping"
                                    (change)="copyShippingAddress($event)" />
                                <span class="text-sm" for="sameAsShipping">{{
                                    'SAME_AS_SHIPPING_ADDRESS' | translate }}</span>
                            </div>
                        </div>
                        <div class="flex-column">
                            <div class="input-box">
                                <span>{{ 'CONTACT_NAME' | translate }} *</span>
                                <input required type="text" formControlName="contactNameAndSurname" class="form-control"
                                    id="billingContactNameAndSurname" />
                                <div *ngIf="createClinicForm.get('billingAddress.contactNameAndSurname').invalid && (createClinicForm.get('billingAddress.contactNameAndSurname').dirty || createClinicForm.get('billingAddress.contactNameAndSurname').touched)"
                                    class="text-danger">
                                    <div
                                        *ngIf="createClinicForm.get('billingAddress.contactNameAndSurname').errors?.['required']">
                                        {{ 'FIELD_REQUIRED' | translate }}</div>
                                </div>
                            </div>
                            <div class="input-box">
                                <span>{{ 'COUNTRY' | translate }} *</span>
                                <input required type="text" formControlName="country" class="form-control"
                                    id="billingCountry" />
                                <div *ngIf="createClinicForm.get('billingAddress.country').invalid && (createClinicForm.get('billingAddress.country').dirty || createClinicForm.get('billingAddress.country').touched)"
                                    class="text-danger">
                                    <div *ngIf="createClinicForm.get('billingAddress.country').errors?.['required']">
                                        {{ 'FIELD_REQUIRED' | translate }}</div>
                                </div>
                            </div>
                            <div class="input-box">
                                <span>{{ 'CITY' | translate }} *</span>
                                <input required type="text" formControlName="city" class="form-control"
                                    id="billingCity" />
                                <div *ngIf="createClinicForm.get('billingAddress.city').invalid && (createClinicForm.get('billingAddress.city').dirty || createClinicForm.get('billingAddress.city').touched)"
                                    class="text-danger">
                                    <div *ngIf="createClinicForm.get('billingAddress.city').errors?.['required']">
                                        {{ 'FIELD_REQUIRED' | translate }}</div>
                                </div>
                            </div>
                            <div class="input-box">
                                <span>{{ 'PROVINCE' | translate }}</span>
                                <input type="text" formControlName="province" class="form-control"
                                    id="billingProvince" />
                            </div>
                            <div class="input-box">
                                <span>{{ 'STREET_NAME' | translate }}</span>
                                <input type="text" formControlName="streetNameAndNumber" class="form-control"
                                    id="billingStreetNameAndNumber" />
                            </div>
                            <div class="input-box">
                                <span>{{ 'APARTMENT' | translate }}</span>
                                <input type="text" formControlName="apartmentOrOthers" class="form-control"
                                    id="billingApartmentOrOthers" />
                            </div>
                            <div class="input-box">
                                <span>{{ 'POSTAL_CODE' | translate }}</span>
                                <input type="text" formControlName="postalCode" class="form-control"
                                    id="billingPostalCode" />
                            </div>
                            <div class="input-box">
                                <span>{{ 'PHONE_NUMBER' | translate }}</span>
                                <input type="text" formControlName="phoneNumber" class="form-control"
                                    id="billingPhoneNumber" />
                            </div>
                        </div>
                    </div>

                    <div *ngIf="userService.user.role === 'ROLE_DISTRIBUTOR_PROFESSIONAL' && userService.user.edserWebhook"
                        formGroupName="connectedPlatform">
                        <h4 class="mt-4">{{ 'CONNECTED_PLATFORMS' | translate }}</h4>
                        <div class="flex-column">
                            <span class="mb-3">Edser</span>
                            <div class="input-box">
                                <span>{{ 'IDENTIFIER' | translate }}</span>
                                <input type="text" formControlName="identifier" class="form-control"
                                    id="connectedPlatformIdentifier" />
                            </div>
                            <div class="input-box">
                                <span>{{ 'MULTIPLE_IDENTIFIER' | translate }}</span>
                                <ng-select [items]="createClinicForm.get('connectedPlatform.identifiersList').value"
                                    placeholder="{{ 'ADD_IDENTIFIER' | translate }}" appendTo="body" multiple="true"
                                    formControlName="identifiersList" [addTag]="true"
                                    (clear)="updateNewClinicMultipleIdentifiers()"
                                    (change)="updateNewClinicMultipleIdentifiers()">
                                </ng-select>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>



    <div class="card-footer mt-3">
        <div class="form-group mb-0 text-right">
            <button type="submit" mat-raised-button color="primary"
                [disabled]="!createClientForm.valid || !createClinicForm.valid" (click)="createClient()">{{'CREATE'
                | translate}}</button>
        </div>
    </div>
</p-dialog>